import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSiteAssetViewUid } from 'services/redux/selectors/serviceDesk/assets';
import conxtdOut from 'apis/conxtdOut';
import Alert from 'components/Common/Alert';

export function useSiteAssetViewHandler() {
  const dispatch = useDispatch();
  const uid = useSelector(getSiteAssetViewUid);
  const [photoFile, setPhotoFile] = useState(null);

  /**
   * Handler function that runs the alert & submission logic for - Site Asset View
   */
  const handleSiteAssetView = useCallback(async ({
    sudoSiteId,
    editData,
    setLoadingSubmitEdit,
    setForceReload,
    setEditMode,
    setSiteViewData,
  }) => {

    if (editData) {
      const photoInData = (editData?.find((f) => f.field_name === "Photo")?.value) ?? null;
      setPhotoFile(photoInData)
    }

    const result = await Alert({
      title: 'Are you sure you want to save these changes?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    });

    if (!result.value) return;

    if (!sudoSiteId || !editData) return;

    try {
      setLoadingSubmitEdit(true);

      const formData = new FormData();
      editData.forEach(({ id, value, field_name }) => {
        if (value instanceof File && photoFile !== null) {
          formData.append(id, photoFile)
        } else if (value !== null && field_name === "next_maintenance_date") {
          formData.append(field_name, value)
        } else if (value !== null) {
          formData.append(id, value)
        }
      });

      uid && await conxtdOut.post(`/company-asset-values/edit/${uid}`, formData);

      const getSiteViewData = () => {
        // setLoadingSiteViewData(true);
        const getData = conxtdOut.get(`/company-asset-values/site-asset-view/${uid}`);
        getData.then((response) => {
            // if (renderOnLoad) {setRenderOnLoad(false)};
            // setLoadingSiteViewData(false);
            setSiteViewData(response.data)
          })
          .catch((error) => {
            console.log(error)
            // setLoadingSiteViewData(false);
            // if (renderOnLoad) {setRenderOnLoad(false)};
          });
        }
    
      setLoadingSubmitEdit(false);
      Alert({
        text: 'Changes to asset were successful',
        icon: 'success',
        timerProgressBar: true,
        timer: 5000,
      });

      setEditMode(false);
      setForceReload(true);
      getSiteViewData();
      
    } catch (error) {
      console.error(error);
      setLoadingSubmitEdit(false);
      Alert({
        text: 'An issue occurred. Please try again later.',
        icon: 'error',
      });
    }
  }, [dispatch, uid]);

  return { handleSiteAssetView };
}
